import React, { useState, useEffect, useContext } from 'react';
import iconPlay from '../../images/icon-play-blk.svg';
import { getVideoThumbnail, getVideoUrl } from '../../utils/functions';
import { AppContext } from '../../apollo/wrap-root-element';

export default function VideoSection({
  section,
  from,
  chapterTitle,
  isFeaturedVideo,
  postBanner,
  banner,
  featuredVideoDuration,
  compactRatio,
  scrollId,
  enforceBanner,
}) {
  const [isPlaying, setIsPlaying] = useState(false);
  const { readvideoPlaying, setreadVideoPlaying } = useContext(AppContext);

  const handleVideoPlay = () => {
    setIsPlaying(true);
    if (from !== 'gc') {
      setreadVideoPlaying(true);
    }
  };

  useEffect(() => {
    return () => {
      if (readvideoPlaying) {
        setreadVideoPlaying(false);
      }
    };
  }, [readvideoPlaying, setreadVideoPlaying]);

  const videoId = section && isFeaturedVideo ? section?.text : section?.content?.videoId?.text;
  const videoURL = getVideoUrl(videoId);
  const thumbnailURL = enforceBanner
    ? banner
    : from === 'gc'
    ? postBanner || banner
    : postBanner || banner || getVideoThumbnail(videoId, 'maxresdefault');

  return (
    <div
      className={`${from === 'gc' ? `media ${compactRatio ? 'ratio_gc' : 'ratio_16-9'}` : 'media ratio_16-9'}`}
      id={scrollId}
    >
      {featuredVideoDuration?.text && !isPlaying && (
        <>
          <div className="videoDurationGC">{featuredVideoDuration?.text}</div>
          <div className="gcfeaturedVideoOverlay"></div>
        </>
      )}
      <iframe
        width="560"
        height="315"
        src={`${videoURL}${isPlaying ? '&autoplay=1&rel=0' : ''}`}
        style={{ display: isPlaying ? 'inherit' : 'none' }}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
      {!isPlaying && (
        <>
          <div
            className={`m_overlay-image religious_imgCover ${from === 'gc' ? 'bgImage' : 'imgCover'}`}
            style={{
              backgroundImage: `url(${thumbnailURL})`,
            }}
          />
          <div
            className={`media-content  ${from !== 'gc' && 'media-content-read'}`}
            id={from === 'gc' ? 'media-content-gc' : ''}
          >
            <div className="btn btn-sm btn-primary-ii btn-play-icon" onClick={handleVideoPlay}>
              <img src={iconPlay} alt="Icon Play" />
            </div>
            {featuredVideoDuration?.text && !isPlaying ? <h3 className="gcvideoTitle">{chapterTitle?.text}</h3> : ''}
          </div>
        </>
      )}
    </div>
  );
}
